import React, { Fragment, useState, useEffect } from "react";
import { Form, Formik, Field } from "formik";
import * as Yup from "yup";
import { TextField } from "formik-material-ui";
import { set_coupons } from "../../redux/actions/CouponsAction";
import { connect } from "react-redux";
import { apiJson } from "../../api/Api";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import Select from "react-select";
import moment from "moment";
import "./couponmodal.scss";
import { getCouponClass, getRandomInt } from "../../utils/utils";

const discType = [
  { value: "percentage", label: "Percentage" },
  { value: "flat_amount", label: "Flat Amount" },
];

const show_on_product_values = [
  { value: "1", label: "Yes" },
  { value: "0", label: "No" },
];

const CouponModal = (props) => {
  const [loading, setLoading] = useState(false);
  const [discountType, setDiscountType] = useState(discType[0]);
  const [initialValues, setInitialValues] = useState(null);
  useEffect(() => {
    setInitialValues({
      code: props.formData?.code || "",
      discount: props.formData?.discount * 100 || "",
      max_discount: props.formData?.max_discount || "",
      start_date: props.formData
        ? moment(new Date(props.formData.start_date)).format("YYYY-MM-DDTHH:mm")
        : "",
      expiry: props.formData
        ? moment(new Date(props.formData.expiry)).format("YYYY-MM-DDTHH:mm")
        : "",
      discount_type: props.formData?.discount_type || "percentage",
      flat_discount: props.formData?.flat_discount || "",
      minimum_order_amount: props.formData?.min_order_amount || "",
      max_usage_count: props.formData?.max_usage_count || "",
      show_on_product: props.formData?.show_on_product || "",
    });
    props.formData?.discount_type === "flat_amount" &&
      setDiscountType(discType[1]);
    // eslint-disable-next-line
  }, []);
  let One_hour = 60 * 60 * 1000;
  let minusOneHour = new Date() - One_hour;

  const coupanSchema = Yup.object().shape({
    code: Yup.string().required("Required"),
    discount: Yup.number("Should be number")
      .min(1, "Should be greater than 1")
      .max(100, "Should be less than 100")
      .required("Required"),
    max_discount: Yup.number("Should be number").positive(
      "Should be positive number"
    ),
    start_date: props.editPage
      ? Yup.date().required("Required")
      : Yup.date()
          .required("Required")
          .test(
            "start_date",
            "Past date not allowed",
            (value) => new Date(value) > new Date(minusOneHour)
          ),
    expiry: Yup.date()
      .required("Required")
      .test("expiry", "Past date not allowed", (value) => value > new Date())
      .min(Yup.ref("start_date"), "End date can't be before start date"),
    discount_type: Yup.string().required("Required"),
    max_usage_count: Yup.number("Must be number"),
  });

  const amountCoupanSchema = Yup.object().shape({
    code: Yup.string().required("Required"),
    start_date: props.editPage
      ? Yup.date().required("Required")
      : Yup.date()
          .required("Required")
          .test(
            "start_date",
            "Past date not allowed",
            (value) => new Date(value) > new Date(minusOneHour)
          ),
    expiry: Yup.date()
      .required("Required")
      .test("expiry", "Past date not allowed", (value) => value > new Date())
      .min(Yup.ref("start_date"), "End date can't be before start date"),
    discount_type: Yup.string().required("Required"),
    flat_discount: Yup.number("Must be number").required("Required"),
    minimum_order_amount:
      Yup.number("Must be number").positive("Must be positive"),
    max_usage_count: Yup.number("Must be number"),
  });

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const createCoupon = (values) => {
    setLoading(true);
    apiJson.coupons
      .createCoupon(
        discountType?.value?.toLowerCase() === "flat_amount"
          ? {
              coupon: {
                code: values.code,
                flat_discount: values.flat_discount,
                min_order_amount:
                  values.minimum_order_amount?.length === 0
                    ? null
                    : values.minimum_order_amount,
                start_date: new Date(values.start_date),
                expiry: new Date(values.expiry),
                discount_type: discountType?.value,
                max_usage_count:
                  values.max_usage_count?.length === 0
                    ? null
                    : parseInt(values.max_usage_count),
                show_on_product: values.show_on_product
              },
            }
          : {
              coupon: {
                code: values.code,
                discount: (values.discount / 100).toString(),
                max_discount:
                  values.max_discount?.length === 0
                    ? null
                    : parseInt(values.max_discount),
                start_date: new Date(values.start_date),
                expiry: new Date(values.expiry),
                discount_type: discountType?.value,
                max_usage_count:
                  values.max_usage_count?.length === 0
                    ? null
                    : parseInt(values.max_usage_count),
                show_on_product: values.show_on_product
              },
            }
      )
      .then((response) => {
        if (response.success) {
          props.set_coupons({ coupons: [...props.coupons, response.data] });
          setLoading(false);
          props.createClick();
          message = response.message
            ? response.message
            : "Coupon Created Succesfully";
          showSuccess();
        } else if (!response.status) {
          setLoading(false);
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
          props.createClick();
        } else {
          setLoading(false);
          props.createClick();
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
              ? response.errors
              : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
  };

  const editCoupon = (values) => {
    setLoading(true);
    apiJson.coupons
      .updateCoupon(props.formData.id, {
        coupon: {
          start_date: new Date(values.start_date),
          expiry: new Date(values.expiry),
          show_on_product: values.show_on_product
        },
      })
      .then((response) => {
        if (response.success) {
          if (values.show_on_product == "1") {
            window.location.reload(false);
          }
          else {
            props.set_coupons({
              coupons: props.coupons.map((cop) =>
                cop.id === response.data.id ? response.data : cop
              ),
            });
            setLoading(false);
            props.cancleClick();
          }
        } else if (!response.status) {
          setLoading(false);
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          setLoading(false);
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
              ? response.errors
              : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
  };

  return (
    <Fragment>
      <div className="coupon-modal">
        <div className="coupon-header w-100">{props.heading}</div>
        <Formik
          initialValues={initialValues}
          validationSchema={
            discountType?.value === "flat_amount"
              ? amountCoupanSchema
              : coupanSchema
          }
          enableReinitialize={true}
          onSubmit={(values) => {
            if (props.editPage) {
              editCoupon(values);
            } else {
              createCoupon(values);
            }
          }}
        >
          {({ errors, touched, values, setFieldTouched, setFieldValue }) => (
            <Form>
              <div className="boday-row w-100">
                <div className="input-group-row w-100 d-flex flex-column">
                  <div className="input-row d-flex align-items-start w-100">
                    <div className="label">Discount Type:</div>
                    <div className="value">
                      <Select
                        style={{ width: "100%" }}
                        value={discountType}
                        options={discType}
                        onChange={(val) => setDiscountType(val)}
                        className="discount-select"
                        classNamePrefix="control"
                        isDisabled={props.editPage ? true : false}
                      />
                    </div>
                  </div>
                  <div className="input-row d-flex align-items-start w-100">
                    <div className="label">Coupon Code:</div>
                    <div className="value">
                      <Field
                        style={{ width: "100%", cursor: "pointer" }}
                        component={TextField}
                        name="code"
                        type="text"
                        disabled={props.editPage || false}
                        className={getCouponClass(errors.code && touched.code)}
                      />
                    </div>
                  </div>
                  <div className="input-row d-flex align-items-start w-100">
                    <div className="label">Start Date:</div>
                    <div className="value">
                      <Field
                        style={{ width: "100%" }}
                        component={TextField}
                        name="start_date"
                        type="datetime-local"
                        disabled={false}
                        className={getCouponClass(
                          errors.start_date && touched.start_date
                        )}
                      />
                    </div>
                  </div>
                  <div className="input-row d-flex align-items-start w-100">
                    <div className="label">Expire At:</div>
                    <div className="value">
                      <Field
                        style={{ width: "100%", cursor: "pointer" }}
                        component={TextField}
                        name="expiry"
                        type="datetime-local"
                        disabled={false}
                        className={getCouponClass(
                          errors.expiry && touched.expiry
                        )}
                      />
                    </div>
                  </div>
                  {discountType?.value === "flat_amount" ? (
                    <Fragment>
                      <div className="input-row d-flex align-items-start w-100">
                        <div className="label">Discount Amount:</div>
                        <div className="value">
                          <Field
                            style={{ width: "100%", cursor: "pointer" }}
                            component={TextField}
                            name="flat_discount"
                            type="number"
                            disabled={props.editPage || false}
                            className={getCouponClass(
                              errors.flat_discount && touched.flat_discount
                            )}
                          />
                        </div>
                      </div>

                      <div className="input-row d-flex align-items-start w-100">
                        <div className="label">Min. Order Amount:</div>
                        <div className="value">
                          <Field
                            style={{ width: "100%", cursor: "pointer" }}
                            component={TextField}
                            name="minimum_order_amount"
                            type="number"
                            disabled={props.editPage || false}
                            className={getCouponClass(
                              errors.minimum_order_amount &&
                                touched.minimum_order_amount
                            )}
                          />
                        </div>
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <div className="input-row d-flex align-items-start w-100">
                        <div className="label">Discount %:</div>
                        <div className="value">
                          <Field
                            style={{ width: "100%", cursor: "pointer" }}
                            component={TextField}
                            name="discount"
                            type="number"
                            placeholder="example: 10"
                            disabled={props.editPage || false}
                            className={getCouponClass(
                              errors.discount && touched.discount
                            )}
                          />
                        </div>
                      </div>
                      <div className="input-row d-flex align-items-start w-100">
                        <div className="label">Max. discount allowed:</div>
                        <div className="value">
                          <Field
                            style={{ width: "100%", cursor: "pointer" }}
                            component={TextField}
                            name="max_discount"
                            type="number"
                            disabled={props.editPage || false}
                            className={getCouponClass(
                              errors.max_discount && touched.max_discount
                            )}
                          />
                        </div>
                      </div>
                    </Fragment>
                  )}
                  <div className="input-row description-row d-flex align-items-start w-100">
                    <div className="label">Max. Usage Count:</div>
                    <div className="value">
                      <Field
                        style={{ width: "100%", cursor: "pointer" }}
                        component={TextField}
                        name="max_usage_count"
                        type="number"
                        disabled={props.editPage || false}
                        className={getCouponClass(
                          errors.max_usage_count && touched.max_usage_count
                        )}
                      />
                    </div>
                  </div>
                  <div className="input-row d-flex align-items-start w-100">
                    <div className="label">Show on product:</div>
                    <div className="value">
                      <Select
                        style={{ width: "100%" }}
                        value={
                          values?.show_on_product
                            ? values?.show_on_product === "1"
                              ? show_on_product_values[0]
                              : show_on_product_values[1]
                            : ""
                        }
                        options={show_on_product_values}
                        onChange={(value) =>
                          setFieldValue("show_on_product", value.value)
                        }
                        className="discount-select"
                        classNamePrefix="control"
                      />
                    </div>
                  </div>
                </div>
                <div className="buttons-row w-100 d-fex justify-content-start align-items-start">
                  <button
                    className="cancel-button"
                    type="button"
                    onClick={props.cancleClick}
                  >
                    Cancel
                  </button>
                  <button
                    key={getRandomInt(1, 1000)}
                    className="create-button"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <ClipLoader color="#fff" loading size={15} />
                    ) : props.editPage ? (
                      "Update"
                    ) : (
                      "Create"
                    )}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    coupons: state.coupon.coupons,
  };
};

const mapDispatchTopProps = { set_coupons };

export default connect(mapStateToProps, mapDispatchTopProps)(CouponModal);
